import { useAuth } from "../composables/useAuth.mjs";
import { useInit } from "../composables/useInit.mjs";
export const smvpGetOAuthAuthorization = async () => {
  if (!useInit.getInit()) {
    throw new Error("nuxt-saasmvp-oauth: You need to run smvpInitAuth() in your app FIRST");
  }
  let status = 0;
  const token = useAuth.getToken();
  try {
    const response = await fetch("/api/smvp/smvp-authorize", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-TOKEN": token
      }
    });
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
    const json = await response.json();
    status = json.status;
  } catch (error) {
    console.log(error);
  }
  return status;
};
